import _ from "lodash";
import { ll } from "../../core/ll";
import K_HTML from "../templates/K_HTML";
import K_MenuLI from "../templates/K_MenuLI";
import K_MenuUL from "../templates/K_MenuUL";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

var buildTreeViewHTML = function (params: MenuOptions) {
    var html = "";
    var menu = "";

    let nextItemId = 1;

    $.each(params.items, function (index, item) {
        if (!item.id) {
            item.id = nextItemId.toString();
            nextItemId += 1;
        }
        item.checkbox = item.checkbox || params.checkbox || "";
        item.dataValue = item.dataValue || item.id;
        item.labelBind = ll(item.labelBind) || "";
        if (params.shouldPrefix) {
            item.shouldPrefix = true;
            item.prefix = params.prefix || params.id + "_";
        }
        if (item.routerLink) {
            item.classes = (item.classes || "") + " router-link router-link-" + item.routerLink;
        }

        if (item.items) {
            item.listItems = buildTreeViewHTML(item);
            menu += kendo.template(K_MenuLI)(item);
        } else {
            menu += kendo.template(K_MenuLI)(item);
        }
    });

    params.contents = menu;
    html += kendo.template(K_MenuUL)(params);

    return html;
};

export interface MenuOptions extends ComponentOptions, kendo.ui.TreeViewOptions {
    HTML?: string;
    bsc?: string;
    items?: MenuItem[];
    contents?: string;
    checkbox?: string;
    shouldPrefix?: boolean;
    prefix?: string;
    dataValue?: string;
}

export interface MenuItem {
    id?: string;
    checkbox?: string;
    dataValue?: string;
    codeType?: string;
    labelBind?: string;
    shouldPrefix?: boolean;
    prefix?: string;
    items?: MenuItem[];
    listItems?: string;
    classes?: string;
    bsc?: string;
    expanded?: boolean;
    expands?: boolean;
    href?: string;
    routerLink?: string;
}

export class Menu extends TemplateComponent {

    options: MenuOptions;

    constructor(options: MenuOptions) {
        super(K_HTML, options);
    }

    preRender() {
        const options = this.options;

        if (options.dataSource) {
            options.HTML = "<div id='" + (options.id || "") + "'></div>";
            options.template = options.template || `
                <span
                    # if (data.item.id) { # id="#= data.item.id #" # } #
                    class="bind-label #= data.item.classes || "" #"
                    # if (data.item.labelBind) { # data-bind="text: #= data.item.labelBind #" # } #
                ></span>
            `;
        } else {
            options.HTML = buildTreeViewHTML(options);
        }
    }

    create() {
        var menu = $("#" + this.id);

        menu.kendoTreeView(this.options);

        menu.data("kendoTreeView").bind("change", function (e) {
            e.preventDefault();
        });
        menu.data("kendoTreeView").bind("select", function (e) {
            e.preventDefault();
        });

        menu.tie("click", "li", function (e) {
            var node = $(this);

            if (node.children("ul").length > 0) {
                return;
            }

            menu.find(".k-state-selected").removeClass("k-state-selected");
            menu.find(".k-state-hover").removeClass("k-state-hover");

            $(node.children().get(0)).children(".k-in").addClass("k-state-selected");
        });

        menu.tie("mouseenter", "li", function (e) {
            var node = $(this);

            if (node.children("ul").length > 0) {
                return;
            }

            $(node.children().get(0)).children(".k-in").addClass("k-state-hover");
        });

        menu.tie("mouseleave", "li", function (e) {
            var node = $(this);

            if (node.children("ul").length > 0) {
                return;
            }

            $(node.children().get(0)).children(".k-in").removeClass("k-state-hover");
        });

        menu.addClass("z-menu");

        _.forEach(this.options.items, item => {
            if (item.href) {
                var element = $("#" + item.prefix + item.id + "_LI");

                element.data("me", {
                    setActive: () => {
                        $(element.children().get(0)).children(".k-in").addClass("k-state-selected");
                    },
                    setInactive: () => {
                        $(element.children().get(0)).children(".k-in").removeClass("k-state-selected");
                    },
                    show: () => {
                        element.removeClass("hidden");
                    },
                    hide: () => {
                        element.addClass("hidden");
                    }
                });

                element.on("click", () => {
                    this.router.navigate(item.href);
                });
            }
        });
    }

}
